import configuration from '~/configuration'

const Head = () => {
  const siteUrl = configuration.site.siteUrl

  if (!siteUrl) {
    throw new Error(`Please add the property siteUrl in the configuration`)
  }

  const structuredData = {
    name: configuration.site.name,
    url: siteUrl,
    logo: `${siteUrl}/assets/images/favicon/bnsn_favicon.png`,
    '@context': 'https://schema.org',
    '@type': 'Organization', // change to person for Personal websites
  }

  return (
    <>
      <title>{configuration.site.name}</title>
      <meta charSet="utf-8" />

      <link rel="apple-touch-icon" sizes="180x180" href="/assets/images/180h/bnsn-logo-only-2026.png" />

      <link rel="icon" type="image/png" href="/assets/images/favicon/bnsn-logo-only-2026.png" />

      <link rel="icon" type="image/svg+xml" href="/assets/SVG/bnsn-logo-only-2026.svg" />

      <link rel="manifest" href="/assets/images/favicon/site.webmanifest" />

      <link rel="mask-icon" href="/assets/images/favicon/bnsn_favicon.png" color="#000000" />

      <link rel="dns-prefetch" href="//fonts.googleapis.com" />

      <link rel="preconnect" href="https://fonts.gstatic.com" />

      <meta name="viewport" content="width=device-width,initial-scale=1" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-config" content="/favicon/browserconfig.xml" />

      <meta name="theme-color" content={configuration.site.themeColor} />

      <meta name="description" content={configuration.site.description} key="meta:description" />

      <meta property="og:title" key="og:title" content={configuration.site.name} />

      <meta property="og:description" key="og:description" content={configuration.site.description} />

      <meta property="og:site_name" content={configuration.site.siteName} />
      <meta property="twitter:title" content={configuration.site.siteName} />
      <meta property="twitter:card" content="summary_large_image" />

      <meta property="twitter:creator" content={configuration.site.twitterHandle} />

      <script
        async
        key="ld:json"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </>
  )
}

export default Head
